import email from '../assets/email.png';
import mobile from '../assets/mobile.png';
import api from '../assets/api.png';
import cpp from '../assets/cpp.png';
import css from '../assets/css.png';
import figma from '../assets/figma.png';
import flutter from '../assets/flutter.png';
import git from '../assets/git.png';
import graphql from '../assets/graphql.png';
import html from '../assets/html.png';
import javascript from '../assets/javascript.png';
import php from "../assets/php.png"
import mu5 from '../assets/mu5.png';
import node from '../assets/node.png';
import python from '../assets/python.png';
import react from '../assets/react.png';
import redux from '../assets/redux.png';
import sass from '../assets/sass.png';
import typescript from '../assets/typescript.png';
import angular from '../assets/angulerr.png';
import vue from '../assets/vue.png';

import about01 from '../assets/about-1.png';
import about02 from '../assets/about-2.png';
import about03 from '../assets/about-3.png';
import about04 from '../assets/about-4.png';
import about05 from "../assets/about-5.png";
import about06 from "../assets/about-6.png";
import about07 from "../assets/about-7.png";
import about08 from "../assets/about-8.png";
import about09 from "../assets/about-9.png";
import about10 from "../assets/about-10.png";

import profile from '../assets/profile.png';
// import profile2 from '../assets/profile2.png'
import profile2 from '../assets/myProfile.jpg'
import profile3 from '../assets/profile3.jpg'
import circle from '../assets/circle.svg';
import logo from '../assets/bestLogo-removebg-preview.png';

import adidas from '../assets/adidas.png';
import amazon from '../assets/amazon.png';
import asus from '../assets/asus.png';
import bolt from '../assets/bolt.png';
import nb from '../assets/nb.png';
import skype from '../assets/skype.png';
import spotify from '../assets/spotify.png';

export default {
  email,
  mobile,
  api,
  cpp,
  css,
  figma,
  flutter,
  git,
  profile3,
  graphql,
  html,
  profile2,
  javascript,
  mu5,
  node,
  python,
  angular,
  php,
  react,
  redux,
  sass,
  typescript,
  vue,
  about01,
  about02,
  about03,
  about04,
  about05,
  about06,
  about07,
  about08,
  about09,
  about10,
  profile,
  circle,
  logo,
  adidas,
  amazon,
  asus,
  bolt,
  nb,
  skype,
  spotify,
};